<template>
    <toolbar-option type="stacked" :message="message">
        <template slot="secondary">
            <dropdown
                :value="state"
                :options="filteredStates"
                native
                @input="onStateInput"
            />
        </template>

        <template slot="primary">
            <slider
                :value="sliderIndex"
                :values="themeObjectValues"
                @input="onInput"
            />
        </template>
    </toolbar-option>
</template>

<script>
import baseOption from '@/options/mixins/base-option-slider';

export default {
    name: 'font-weight',
    mixins: [baseOption],

    data() {
        return {
            displayName: 'Thickness',
            defaultIndex: 3,
            message: '* some options may not have any effect, depending on the currently loaded font family',
            tailwindDefinitionProp: 'fontWeight',
            state: '',
            states: [
                {
                    text: 'Default',
                    value: '',
                },
                {
                    text: 'Matching',
                    value: 'matching',
                    displayFor: ['a-link', 'nav-dropdown'],
                },
            ],
        };
    },

    computed: {
        filteredStates() {
            const { elementType } = this.selectedElements[0];

            return this.states.filter((state) => {
                if (state.displayFor) {
                    return state.displayFor.includes(elementType);
                }

                return true;
            });
        },
    },
};
</script>
